import { IPlayerGameStats } from "../types/types";
import { compareSeasonsDesc } from "./seasonOrder";

/** Newest season / latest game first. */
export const sortGamesChronologically = (games: IPlayerGameStats[]): IPlayerGameStats[] =>
  [...games].sort((a, b) => {
    const seasonCmp = compareSeasonsDesc(a.season, b.season);
    if (seasonCmp !== 0) return seasonCmp;
    if (a.gameNumber !== b.gameNumber) return b.gameNumber - a.gameNumber;
    return b.id - a.id;
  });
